import React from 'react';
import { Card, CardContent, Box, Typography, Chip } from '@mui/material';

const formatCurrency = (num) => {
  if (num === null || num === undefined) return '-';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 4 }).format(num);
};

const formatEpoch = (n) => {
  if (n === null || n === undefined) return 'N/A';
  try {
    return new Date(Number(n) * 1000).toLocaleString();
  } catch {
    return String(n);
  }
};

const truncate = (s, n = 14) => (!s ? '-' : s.length > n ? `${s.slice(0, n)}…` : s);

const TokenItemsStoryCard = ({ story }) => {
  if (!story || story.type !== 'interesting_trade') return null;
  const { name, chain, token_address, trade = {} } = story;
  const direction = (trade.direction || '').toLowerCase();
  const dirColor = direction === 'buy' ? 'success' : direction === 'sell' ? 'error' : 'default';

  return (
    <Card sx={{ mb: 2, backgroundColor: '#fafafa' }}>
      <CardContent sx={{ pb: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
              {name || token_address || 'Unknown token'}
            </Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary', wordBreak: 'break-all' }}>
              {token_address}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 0.75, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
            {direction && <Chip size="small" label={direction.toUpperCase()} color={dirColor} />}
            {chain && <Chip size="small" label={chain} variant="outlined" />}
            {trade.protocol && <Chip size="small" label={trade.protocol} variant="outlined" />}
          </Box>
        </Box>

        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.5, mt: 1.5 }}>
          <Typography variant="body2" color="text.secondary">Size</Typography>
          <Typography variant="body2" sx={{ textAlign: 'right' }}>{formatCurrency(trade.amount_usd)}</Typography>

          <Typography variant="body2" color="text.secondary">Wallet</Typography>
          <Typography variant="body2" sx={{ textAlign: 'right' }}>{truncate(trade.wallet_address)}</Typography>

          <Typography variant="body2" color="text.secondary">Wallet 24h vol</Typography>
          <Typography variant="body2" sx={{ textAlign: 'right' }}>{formatCurrency(trade.wallet_24h_volume_usd)}</Typography>

          <Typography variant="body2" color="text.secondary">Tx</Typography>
          <Typography variant="body2" sx={{ textAlign: 'right' }}>{truncate(trade.tx_hash)}</Typography>

          <Typography variant="body2" color="text.secondary">Time</Typography>
          <Typography variant="body2" sx={{ textAlign: 'right' }}>{formatEpoch(trade.block_timestamp)}</Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default TokenItemsStoryCard;
